<template>
  <page :basic="true">
    <span slot="header">Content Tree</span>
    <template slot="breadcrumbs">
      <div>
        <a href="#" @click="$router.go(-1)">
          <i class="fas fa-hand-point-left"></i> Go back
        </a>
      </div>
    </template>
    <b-container fluid>
      <b-row>
        <b-col cols="12">
          <p> Select modules and components you would like to see </p>
          <ul v-for="(node, index) in tree">
            <node
              :key="index"
              :node="node"
              class="node"/>
          </ul>
        </b-col>
      </b-row>
    </b-container>
  </page>
</template>

<script>
import { mapState } from 'vuex'
import page from '../../../templates/page'
import node from './node'

export default {
  components: {
    page,
    node
  },
  computed: {
    ...mapState('client', {
      tree: 'contentTree'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/client/content-tree/index.vue